import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("smokin_admin_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;

export const adminLogin = (username, password) =>
    api.post("/auth/login", { username, password }).then((r) => r.data);
export const adminMe = () => api.get("/auth/me").then((r) => r.data);

export const fetchSiteSettings = () => api.get("/site-settings").then((r) => r.data);
export const fetchMenuCategories = () => api.get("/menu/categories").then((r) => r.data);
export const fetchMenuItems = (params = {}) =>
    api.get("/menu/items", { params }).then((r) => r.data);
export const fetchPublicEvents = (params = {}) =>
    api.get("/events/public", { params }).then((r) => r.data);
export const fetchGallery = (params = {}) =>
    api.get("/gallery", { params }).then((r) => r.data);
export const submitInquiry = (payload) =>
    api.post("/booking-inquiries", payload).then((r) => r.data);

// Admin
export const adminFetchMenu = () => api.get("/admin/menu/items").then((r) => r.data);
export const adminCreateMenu = (payload) => api.post("/admin/menu/items", payload).then((r) => r.data);
export const adminUpdateMenu = (id, payload) => api.patch(`/admin/menu/items/${id}`, payload).then((r) => r.data);
export const adminDeleteMenu = (id) => api.delete(`/admin/menu/items/${id}`).then((r) => r.data);

export const adminFetchEvents = () => api.get("/admin/events").then((r) => r.data);
export const adminCreateEvent = (payload) => api.post("/admin/events", payload).then((r) => r.data);
export const adminUpdateEvent = (id, payload) => api.patch(`/admin/events/${id}`, payload).then((r) => r.data);
export const adminDeleteEvent = (id) => api.delete(`/admin/events/${id}`).then((r) => r.data);

export const adminFetchGallery = () => api.get("/admin/gallery").then((r) => r.data);
export const adminCreateGallery = (payload) => api.post("/admin/gallery", payload).then((r) => r.data);
export const adminUpdateGallery = (id, payload) => api.patch(`/admin/gallery/${id}`, payload).then((r) => r.data);
export const adminDeleteGallery = (id) => api.delete(`/admin/gallery/${id}`).then((r) => r.data);
export const adminScanUploads = () => api.post('/admin/gallery/scan-uploads').then((r) => r.data);
export const adminUploadGalleryImage = (file, caption = '', category = 'food', sort_order = 0) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('caption', caption);
    fd.append('category', category);
    fd.append('sort_order', String(sort_order));
    return api.post('/admin/gallery/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
};

export const adminFetchInquiries = () => api.get("/admin/inquiries").then((r) => r.data);
export const adminUpdateInquiry = (id, payload) => api.patch(`/admin/inquiries/${id}`, payload).then((r) => r.data);
export const adminDeleteInquiry = (id) => api.delete(`/admin/inquiries/${id}`).then((r) => r.data);

export const adminUpdateSettings = (payload) => api.patch("/admin/site-settings", payload).then((r) => r.data);

// Orders
export const fetchOrderingStatus = () => api.get("/ordering-status").then((r) => r.data);
export const adminToggleItemAvailability = (id) => api.post(`/admin/menu/items/${id}/toggle-availability`).then((r) => r.data);
export const createOrder = (payload) => api.post("/orders", payload).then((r) => r.data);
export const createCateringDeposit = (payload) => api.post("/payments/catering-deposit", payload).then((r) => r.data);
export const adminFetchOrders = () => api.get("/admin/orders").then((r) => r.data);
export const adminUpdateOrder = (id, payload) => api.patch(`/admin/orders/${id}`, payload).then((r) => r.data);
export const adminFetchDeposits = () => api.get("/admin/catering-deposits").then((r) => r.data);
